// frontend/src/components/notifications/NotificationAlert.jsx
import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useNotificationAlert } from '../../context/NotificationAlertContext';
import './NotificationAlert.css';

const NotificationAlert = () => {
  const { alertMsg } = useNotificationAlert();

  return (
    <AnimatePresence>
      {alertMsg && (
        <motion.div
          className="na-banner"
          initial={{ opacity: 0, y: -16, scale: 0.97 }}
          animate={{ opacity: 1, y: 0,   scale: 1     }}
          exit={{    opacity: 0, y: -16, scale: 0.97  }}
          transition={{ type: 'spring', stiffness: 320, damping: 26 }}
        >
          <span className="na-pulse" />
          <i className="fas fa-bell na-icon"></i>
          <span className="na-text">{alertMsg}</span>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default NotificationAlert;
